<template>
    <div class="carousel-component pages-carousel">
        <carousel
            :breakpoints="{576: {itemsToShow: 2}, 992: {itemsToShow: 3}}"
            :items-to-scroll="1"
            :wrap-around="true"
            :snap-align="true">
            <slide v-for="(page, index) in pages" :key="index">
                <div class="carousel__item card w-100 h-100">
                    <div class="card-img-top">
                        <figure>
                            <div class="image-holder">
                                <img :src="page.photo" alt="">
                            </div>
                            <figcaption>
                                {{ page.name }}
                            </figcaption>
                        </figure>
                        <a :href="page.link" target="_blank" class="stretched-link"></a>
                    </div>
                </div>
            </slide>

            <template #addons>
                <navigation />
            </template>
        </carousel>
    </div>
</template>

<script>
    import { defineComponent } from 'vue';
    import { Carousel, Slide, Navigation } from 'vue3-carousel';

    export default defineComponent({
        name: 'PagesCarousel',
        components: {
            Carousel,
            Slide,
            Navigation,
        },
        props: {
            pages: {
                type: Array,
                default: () => [],
            },
        },
    });
</script>
